import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { EmptyState } from '@/components/ui/EmptyState';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="min-h-full flex items-center justify-center p-6">
      <EmptyState
        icon={Compass}
        title="Page not found"
        description="That page doesn't exist yet, or the URL is wrong."
        action={
          <Link to="/">
            <Button variant="secondary">Back to home</Button>
          </Link>
        }
      />
    </div>
  );
}
